import { List,Record } from "immutable";

import lineStyles from "../../../../constants/lineStyles";
import createFromJS from "../../../createFromJS";

export const ReferenceRecord = Record({
  // Is this type enabled or disabled within the interface?
  enabled: true,
  canDelete: true,
  // the other properties
  id: null,
  key: null,
  label: null,
  types: List(),
  icon: null,
  color: null,
  lineStyle: lineStyles.SOLID,
  bidirectional: false,
  inverseLabel: null,
  showInverse: false,
  showInInspector: false
});

const data = {
  objects: {
    types: "List"
  }
};
createFromJS.registerCallback("ReferenceRecord", createFromJS.createNestedCallback(ReferenceRecord, data));
